<template>
  <div class="store-wrapper">
    <div class="focus-wrapper">
      <span class="focus-title"></span>
      <span class="focus-logo"></span>
      <Nav class="head-nav"></Nav>
    </div>
    <div class="store-wrap">
      <div class="container">
        <ul class="nav-list">
          <li :class="`${current === index ? 'active' : ''}`" v-for="(item, index) in storeList" :key="index" @click="changeActive(index)"> {{ item.area }}</li>
        </ul>
        <div class="store-list" >
          <div class="store-item" v-for="(ele, i) in storeList[current].store_list" :key="i">
            <h6 class="t-name" :style="$isMobile && ele.mTitleStyle ? ele.mTitleStyle : null">怡满分({{ ele.name.split("怡满分")[1] }})</h6>
            <p class="t-address">{{ ele.address }}</p>
            <img :src="ele.images" :alt="ele.name">
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Foot from "../components/Foot.vue";
import Nav from "../components/Nav.vue";
export default {
  components: {
    Foot,
    Nav
  },
  computed: {
    storeList() {
      return this.$globalData.store_detail
    }
  },
  data(){
    return {
      current: 0
    }
  },
  methods: {
    changeActive(index) {
      this.current = index
    }
  }
}
</script>
<style lang="less" scoped>
@media(max-width: 1200px) {
  .head-nav{
    bottom: 0 !important;
  }
  .store-wrapper {
    div.container {
      width: 100% !important;
      padding-top: 12vw !important;
      .nav-list{
        height: 9.8vw !important;
        li{
          
          width: 24vw !important;
          height: 9.8vw !important;
          line-height: 9.8vw !important;
          font-size: 6.8vw !important;
         
        }
      }
      .store-list{
        padding: 6.2vw 6.2vw 12vw 6.2vw !important;
        flex-direction: column;
      }
      .store-item{
        width:  100% !important;
        padding: 0 6.2vw 6.2vw 6.2vw!important;
        height: auto !important;
        .t-name{
          font-size: 6.8vw !important;
          line-height: 13.68vw !important;
          margin-bottom: 4.2vw !important;
        }
        .t-address{
          font-size: 5.2vw !important;
          line-height: 6.86vw !important;
          height:  auto !important;
          margin-bottom: 4.8vw !important;
        }
      }
    }
  }
}
@media(max-width: 1560px) {
  .store-wrapper {
    .container {
      width: 1200px !important;
    }
    .store-list{
      gap: 60px !important;
      .store-item{
        width: 528px !important;
        height: 472px !important;
        .t-name{
          font-size: 38px !important;
        }
      }
    }
  }

}
.focus-wrapper {
  height: 902px;
  position: relative;

  .head-nav {
    position: absolute;
    left: 0;
    bottom: 183px;
  }
}

.store-wrap {
  width: 100%;
  font-family: hanli-min,hanli,Hl0628,Hl0811,Hl0906,Hl1126;
  background: #ffffff;
  color: #463935;

  .container {
    width: 1400px;
    margin: 0 auto;
    color: #473935;
    padding-top: 90px;
    font-family: hanli-min,hanli,Hl0628,Hl0811,Hl0906,Hl1126;

    .nav-list {
      display: flex;
      height: 90px;
      line-height: 90px;
      font-size: 50px;
      margin: 0;
      padding: 0;
      list-style: none;
      border-top: 1px solid #473935;
      border-bottom: 1px solid #473935;
      width: 100%;
      flex-wrap: nowrap;
      overflow-x: scroll;

      li {
        width: 222px;
        margin: 0;
        padding: 0;
        list-style: none;
        cursor: pointer;
        border-right: 1px solid #473935;
        box-sizing: border-box;
        flex-shrink: 0;
        &.active {
          background: #473935;
          color: #ffffff;
        }
      }
    }

    p,
    h6 {
      margin: 0;
      padding: 0;
      font-weight: normal;
    }
    .store-list{
      display: flex;
      padding: 58px 42px 180px 42px;
      gap: 108px;
      flex-wrap: wrap;
    }

    .store-item {
      width: 604px;
      height: 516px;
      padding: 0 42px;
      box-sizing: border-box;
      border: 1px solid #c6bcaf;
      .t-address {
        text-align: left;
        font-size: 25px;
        line-height: 30px;
        margin-bottom: 16px;
        height: 60px;
        overflow: hidden;

      }

      .t-name {
        text-align: left;
        font-size: 42px;
        line-height: 90px;
        position: relative;
        margin-bottom: 8px;
        margin-top: 4px;
        width: 110%;
        &::after{
          content: "";
          position: absolute;
          height: 3px;
          width: 28px;
          background: #473935;
          left: 10px;
          bottom: 0;
        }
      }
    }

  }
}
</style>